import { BANKS, DEAL_STEPS } from '../../../constants';
import { CAR_ORIGIN_TYPES } from '../../../constants/carOrigin';
import { tenant, tripartiteContractEnabled } from '../../../brand/tenant';

/**
 * ÐÐµÑÐ²ÑÐ¹ ÑÐ°Ð³ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° Ð±Ð°Ð½ÐºÐ°. ÐÑÐ½ÐµÑÐµÐ½ Ð¸Ð· onBankSelect, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð´Ð»Ñ
 * Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð¼ÐµÐ¶Ð´Ñ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ Ð±Ð°Ð½ÐºÐ° Ð¸ ÑÑÐ¸Ð¼ ÑÐ°Ð³Ð¾Ð¼ Ð²ÐºÐ»Ð¸Ð½Ð¸Ð²Ð°ÐµÑÑÑ
 * ÑÐ¾ÑÐ¼Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½ÐµÐ³Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° â Ð¸ Ð²ÐµÑÐ½ÑÑÑÑÑ Ð² Ð¿Ð¾ÑÐ¾Ðº Ð½ÑÐ¶Ð½Ð¾ Ð² ÑÑ Ð¶Ðµ ÑÐ¾ÑÐºÑ.
 */
const bankFirstStep = (bankId, appeal) => {
  switch (bankId) {
    case BANKS.HALYK:
      return DEAL_STEPS.HALYK.WAITING_FOR_PAYMENT;
    case BANKS.FREEDOM:
      // ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾ Ð¸Ð´ÑÑ Ð¿Ð¾ ÑÐºÐ¾ÑÐ¾ÑÐµÐ½Ð½Ð¾Ð¼Ñ Ð¼Ð°ÑÑÑÑÑÑ Ð¸ Ð½Ð°ÑÐ¸Ð½Ð°ÐµÑÑÑ Ñ ÐÐÐ;
      // ÑÐºÑÐ°Ð½ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½Ð° ÑÐ°Ð¹ÑÐµ Ð±Ð°Ð½ÐºÐ° Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ðº Ð½Ð¾Ð²ÑÐ¼ Ð°Ð²ÑÐ¾.
      return (appeal?.stockType || '').toUpperCase().startsWith('THRIFT')
        ? DEAL_STEPS.FREEDOM.SIGN_CONTRACT
        : DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE;
    case BANKS.FORTE:
      return DEAL_STEPS.FORTE.WAITING_FOR_PAYMENT;
    case BANKS.BEREKE:
      return DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS;
    case BANKS.BCK:
      return DEAL_STEPS.BCK.WAITING_FOR_PAYMENT;
    case BANKS.ALTYN:
      return DEAL_STEPS.ALTYN.WAITING_FOR_PAYMENT;
    case BANKS.EURAZ:
      return DEAL_STEPS.EURAZ.SIGN_CONTRACT;
    default:
      return DEAL_STEPS.NOTARIAL_DOCUMENTS;
  }
};

/**
 * ÐÐ²ÑÐ¾ Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â Ð½ÑÐ¶ÐµÐ½ ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ.
 * Ð£ Ð±ÑÐ¾ÐºÐµÑÐ°, Ð³Ð´Ðµ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð²ÑÐºÐ»ÑÑÐµÐ½ (JetQ), ÑÐ´ÐµÐ»ÐºÐ° Ð¸Ð´ÑÑ Ð¾Ð±ÑÑÐ½ÑÐ¼ Ð¿ÑÑÑÐ¼ Ð±Ð°Ð½ÐºÐ°.
 */
export const isConsignmentDeal = (cars, current = tenant) =>
  tripartiteContractEnabled(current) &&
  (cars || []).some((item) => item?.originCarId === CAR_ORIGIN_TYPES.CONSIGNMENT);

/**
 * ÐÑÐ´Ð° ÑÑÐ¾Ð´Ð¸Ñ ÑÐ´ÐµÐ»ÐºÐ° Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° Ð±Ð°Ð½ÐºÐ°. ÐÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð°Ñ ÑÐ¾ÑÐºÐ° Ð¿ÑÐ°Ð²Ð´Ñ: Ð¸
 * onBankSelect, Ð¸ ÑÑÑÐµÐ»ÐºÐ° Â«âÂ» Ð½Ð° ÑÐ°Ð³Ðµ Ð±Ð°Ð½ÐºÐ¾Ð² (DealCredits) Ð´Ð¾Ð»Ð¶Ð½Ñ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾
 * Ð·Ð°Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ Ð½Ð° ÑÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ, Ð¸Ð½Ð°ÑÐµ ÑÐ°Ð³ Ð¾Ð±ÑÐ¾Ð´Ð¸ÑÑÑ.
 */
export const stepAfterBankSelect = (bankId, appeal, cars) =>
  isConsignmentDeal(cars) ? DEAL_STEPS.TRIPARTITE_CONTRACT : bankFirstStep(bankId, appeal);

export default bankFirstStep;
